import React from 'react';
import { genKey } from '../../utils/utils';
import { Stack, Checkbox, TextField } from '@fluentui/react';
import i18n from "../../i18n";

import { getTheme } from '@fluentui/react';
import { Translation } from 'react-i18next';


interface IProps {
    selected: boolean;
    callbackEnable: any;
    callbackChangeNote: any;
}

interface IState {
    
}

export class CardKeyboard extends React.Component <IProps , IState> {
    constructor(props: IProps) {
        super(props);
    }
    render() {
        const title = "description.keyboardHeadline"

        const theme = getTheme();
        const isMobile = document.documentElement.clientWidth < 800;
        return (

            <><div>
                <div style={{ paddingLeft: isMobile ? 0 : 30 }}>
                    <h3 style={{ fontFamily: 'AvertaPE-Extrabold' }}><Translation>{(t) => t(title).toUpperCase()}</Translation></h3>
                </div>
            </div>
            <div style={{ boxShadow: theme.effects.elevation16, padding: 30, backgroundColor: 'white', marginTop: 10 }}>
                <Stack tokens={{ childrenGap: 30 }}>
                    <Checkbox
                        key={genKey("cb_noteEnabled")}
                        id="cb_noteEnabled"
                            label={i18n.t("description.hasHeyboard")}
                        onChange={this.props.callbackEnable}
                        checked={this.props.selected} />
                </Stack>
            </div></>
        );
    }

}